<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30.667 32">
    <path d="M27.947 3.47H25.297V1.35C25.297.5 24.493 0 23.651 0h-2.262c-.844 0-1.457.501-1.457 1.35v2.12h-9.199V1.35C10.733.5 10.12 0 9.277 0h-2.26c-.844 0-1.649.501-1.649 1.35v2.12H2.915A2.844 2.844 0 00.003 6.438v22.284C.003 30.419 1.229 32 2.915 32H27.75c1.686 0 2.913-1.581 2.913-3.277V6.439a2.847 2.847 0 00-2.717-2.968zm-6.772-2h2.556v4.415h-2.556zm-14.239 0h2.19v4.415h-2.19zm21.905 27.333c0 .844-.533 1.726-1.369 1.726H2.83c-.836 0-1.369-.882-1.369-1.726V12.505h27.381zm.36-22.568v4.432H1.465V6.235a1.327 1.327 0 011.187-1.448H5.32v.862c0 .863.808 1.491 1.656 1.491h2.272a1.437 1.437 0 001.464-1.49v-.863h9.245v.862a1.44 1.44 0 001.387 1.491h2.35c.847 0 1.656-.628 1.656-1.49v-.863h2.466a1.317 1.317 0 011.386 1.45z"/>
    </svg>
</template>

<script>
export default {}
</script>
